<template>
    <div class="m-rank-view">
        <div class="my-kill">
            我的击败数：<em>{{ $store.state.account.kill || 0 }}</em>
            <div class="u-btn reflash" @click="rank_update(1)"></div>
        </div>
        <div class="evt-info kill-text">
            <p>{{ $global.activityTime }}每日18:00-23:59，</p>
            <p>参与天命·荆州争霸地图，获得的累计击败数将计入排名。</p>
            <p>排行榜将于每日10:00更新，并于9月29日10:00前公布最终排名。</p>
        </div>

        <div class="m-rank">
            <div class="update-time">本次更新时间：<em>{{ update_time }}</em></div>

            <div class="table-view">
                <div class="rank-table">

                    <div class="data-table">
                        <!-- <vuescroll :ops="ops"> -->
                        <table class="main-table m-rank">
                            <tbody id="J-rank">
                                <tr v-for="(item,index) in list.slice(now_page * perpage , perpage * (now_page + 1))" :key="index">
                                    <td class="rank">
                                        <div :class="'rank-' + item.rank">{{ item.rank }}</div>                           
                                    </td>
                                    <td class="area-name">{{ $global.queryArea(item.zid) }}</td>
                                    <td class="player-name"><p>{{ $base64.decode64(item.char_name) }}</p></td>
                                    <td class="kill">{{ item.kill_hero_nums }}</td>                           
                                </tr>

                            </tbody>
                        </table>

                        <table class="last-rank">
                            <tbody class="r-160">
                                <tr v-if="list.length">
                                    <td class="rank">
                                        <div :class="'rank-' + list[list.length-1].rank">{{ list[list.length-1].rank }}</div>                           
                                    </td>
                                    <td class="area-name">{{ $global.queryArea(list[list.length-1].zid) }}</td>
                                    <td class="player-name"><p>{{ $base64.decode64(list[list.length-1].char_name) }}</p></td>
                                    <td class="kill">{{ list[list.length-1].kill_hero_nums }}</td>                           
                                </tr>                                                            
                            </tbody>
                        </table>
                        <!-- </vuescroll> -->
                    </div>

                </div>

                <div class="rank-ctrl-view">
                    
                    <div class="page" v-if="list.length">
                        <div class="u-btn prev" @click="prev" :class="{'disabled' : now_page == 0}"></div>
                        <div class="page-detail"><span class="now">{{ now_page + 1 }}</span>/10</div>
                        <div class="u-btn next" @click="next" :class="{'disabled' : now_page == 9}"></div>
                    </div>

                    <div class="u-btn reward-show" @click="$rank_Modal()"></div>
                </div>
            </div>


        </div>        
    </div>
</template>

<style scoped>
.m-rank-view{
    width: 711px;
    height: 2000px;
    margin: 0 auto;
    /* padding-bottom: 200px; */
    /* padding: 30px 20px 0; */
    background-position: bottom center;
    background-repeat: no-repeat;
    /* box-sizing: border-box; */
    color: #f5cf9a;
}


.my-kill{
    margin-bottom: 24px;
    padding-bottom: 22px;
    font-weight: 700;
    text-align: center;
    background-image: url(~@/assets/images/line.png);
    background-position: bottom center;
    background-repeat: no-repeat;
}

.my-kill em{
    /* color: #ff6000; */
}

.evt-info{
    padding: 0 15px;
    margin-bottom: 40px;
    text-align: center;
}

.u-btn.reflash{
    display: inline-block;
    width: 39px;
    height: 39px;
    margin-left: 12px;
    background-image: url(~@/assets/images/btn-reflash.png);
    vertical-align: middle;
}

.update-time{
    width: 407px;
    height: 23px;
    line-height: 23px;
    margin: 5px auto 40px;
    color: #f7c680;
    font-size: 20px;
    text-align: center;
    background-image: url(~@/assets/images/bg-time.png);
}

.table-view{
    position: relative;
    width: 742px;
    height: 1720px;
    margin: 0 auto;
    padding-top: 36px;
    box-sizing: border-box;
    background-image: url(~@/assets/images/bg-rank-panel.png);
    transform: translateX(-8px);   
}

.rank-table{
    width: 659px;
    height: 1181px;
    margin: 0 auto;
    padding-top: 48px;
    box-sizing: border-box;
    background-image: url(~@/assets/images/bg-rank.png);
}

.data-table{
    width: 659px;
    height: 1181px;
    margin: 0 auto;
    border-radius: 20px;  
}

.m-rank{
    /* margin-top: 73px; */
    color: #8e492e;
}

.m-rank table{
    width: 658px;
    margin: 0 auto;
}

.m-rank .main-table{
    height: 1132px;
    border-spacing: 0;
}

.m-rank .main-table tbody{
    height: 100%;
}

.m-rank table tr{
    font-size: 18px;
    /* background-color: #fff3be; */
    overflow: hidden;
}

.m-rank table td{
    height: 70px;
}

.m-rank table .rank{
    width: 149px;
    text-align: center;
}

.m-rank table .area-name{
    width: 152px;
    text-align: center;
}

.m-rank table .player-name{
    width: 206px;
}

.player-name p{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    width: 190px;
    height: 70px;
    margin: 0 auto;
    word-break: break-all;
}

.m-rank table .kill{
    text-align: center;
}

.rank .rank-1{
    width: 40px;
    height: 39px;
    margin: 0 auto;
    font-size: 0;
    color: transparent;
    background-image: url(~@/assets/images/icon-1st.png);
}

.rank .rank-2{
    width: 40px;
    height: 39px;
    margin: 0 auto;
    font-size: 0;
    color: transparent;
    background-image: url(~@/assets/images/icon-2nd.png);
}

.rank .rank-3{
    width: 25px;
    height: 36px;
    margin: 0 auto;
    font-size: 0;
    color: transparent;
    background-image: url(~@/assets/images/icon-3rd.png);
}

.u-btn.reward-show{
    width: 262px;
    height: 79px;
    margin: 20px auto 0;
    background-image: url(~@/assets/images/btn-reward-rank.png);
}

.rank-ctrl-view{
    position: absolute;
    left: 50%;
    bottom: 150px;
    transform: translateX(-50%);
}

.rank-ctrl-view .page{
    display: flex;
    align-items: center;
}

.rank-ctrl-view .page .u-btn{
    width: 64px;
    height: 64px;
}
.rank-ctrl-view .page .u-btn.prev{
    background-image: url(~@/assets/images/btn-prev.png);
}
.rank-ctrl-view .page .u-btn.next{
    background-image: url(~@/assets/images/btn-next.png);
}

.rank-ctrl-view .page-detail{
    width: 181px;
    height: 53px;
    line-height: 53px;
    margin: 0 113px;
    color: #fef2d8;
    text-align: center;
    background-image: url(~@/assets/images/bg-page.png);
    background-repeat: no-repeat;
}

.page-detail .now{
    color: #fef2d8;
}

.m-rank .last-rank{
    margin-top: 50px;
    background-color: #eee3cc;
}

table.last-rank, .last-rank td{
    border: 1px solid #d9bf9f;
    border-collapse: collapse;
}

.page-detail .now{
    color: #fef2d8;
}
</style>

<script>
export default {
    data (){
        return {
            list : [],
            now_page: 0,
            perpage : 16,
            update_time :'----',
            ops: {
                rail: {
                    opacity: 1,
                    background : '#e9dda9',
                    size: '9px',
                    gutterOfSide : '0px',
                },
                bar: {
                    background: '#884d19',
                    keepShow : true,
                    size: '9px',
                }
            }, // 在这里设置全局默认配置            
        }
    },
    created (){
        this.rank_update();
    },
    methods : {
        rank_update (type){
            this.$axios.get(ajax_url_map.rank)
            .then(
                res => {
                    this.list = res.data.slice(0,160);
                    this.update_time = res.data[0].action_date;
                    if(type)this.$toast('刷新成功');
                },
                rej => {
                    if(type)this.$toast('9月1日开始统计数据，敬请期待');
                }
            )
        },
        prev (){
            return this.now_page = Math.max(0,--this.now_page)
        },
        next (){
            return this.now_page = Math.min(9,++this.now_page)
        },        
    },
}
</script>


// WEBPACK FOOTER //
// src/components/rank.vue